<div class="user-section">
  <div class="title-section">
    <div class="breadcrumb">
      <span>Dashboard</span>
      <mat-icon>keyboard_arrow_right</mat-icon>
      <span class="current">Users</span>
    </div>
  </div>
  <div class="search-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label class="label">Search</mat-label>
      <input matInput placeholder="Search">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>
  </div>
  <div class="tabs-and-count-section">
    <mat-tab-group class="tabs-section"  (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="All Status"></mat-tab>
      <mat-tab label="Approved"></mat-tab>
      <mat-tab label="Pending"></mat-tab>
      <mat-tab label="Rejected"></mat-tab>
    </mat-tab-group>
    <div class="total-count-section">
      Total Vehicles: 100
    </div>
  </div>
  <div class="table-section">
    <table mat-table [dataSource]="dataSource" matSort class="users-table">
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef> Sr. No</th>
        <td mat-cell *matCellDef="let i = index">
          {{ (paginator.pageIndex * paginator.pageSize) + i + 1 }}
        </td>

      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> User Name</th>
        <td mat-cell *matCellDef="let element"> {{ element.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="contactNo">
        <th mat-header-cell *matHeaderCellDef> Contact No</th>
        <td mat-cell *matCellDef="let element"> {{ element.phoneNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> City</th>
        <td mat-cell *matCellDef="let element"> {{ element.city }}</td>
      </ng-container>
      <ng-container matColumnDef="lastSession">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Session </th>
        <td mat-cell *matCellDef="let element">
          @if (element.latest_session != null) {
            {{ element.latest_session | date:'dd MMM yyyy' }}
          } @else {
            Session Not Yet
          }
        </td>

      </ng-container>
      <ng-container matColumnDef="vehicles">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> vehicles </th>
        <td mat-cell *matCellDef="let element"> {{ element.approved+element.pending+element.rejected }} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Vehicle Status</th>
        <td mat-cell *matCellDef="let element">
          @if(element.approved>=0){<span class="status-badge-approved">
             {{element.approved}}
          </span>}
          @if(element.pending>=0){<span class="status-badge-pending">
           {{element.pending}}
          </span>}
          @if(element.rejected>=0){
          <span class="status-badge-rejected">
            {{element.rejected}}
          </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openUserDetails(row.id)" class="clickable"></tr>
    </table>
  </div>
  <div class="pagination-section">
    <mat-paginator [length]="totalCount"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   aria-label="Select page">
    </mat-paginator>
  </div>
</div>

